export default function (array, property, displayOrder) {
    if (!Array.isArray(array)) {
        return array;
    }
    return array.slice().sort(function (a, b) {
        if (displayOrder !== 'descending' || typeof displayOrder === 'object') {
            return a[property] > b[property] ? 1 : -1; // Ascending order

        } else if (displayOrder === 'descending') {
            return a[property] < b[property] ? 1 : -1; // Descending order
        }
    });
};